import { render, staticRenderFns } from "./LoginElement.vue?vue&type=template&id=cb70a46e&scoped=true&"
import script from "./LoginElement.vue?vue&type=script&lang=js&"
export * from "./LoginElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70a46e",
  null
  
)

export default component.exports